/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();

/*!
Waypoints Inview Shortcut - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(){}function e(t){this.options=i.Adapter.extend({},e.defaults,t),this.axis=this.options.horizontal?"horizontal":"vertical",this.waypoints=[],this.element=this.options.element,this.createWaypoints()}var i=window.Waypoint;e.prototype.createWaypoints=function(){for(var t={vertical:[{down:"enter",up:"exited",offset:"100%"},{down:"entered",up:"exit",offset:"bottom-in-view"},{down:"exit",up:"entered",offset:0},{down:"exited",up:"enter",offset:function(){return-this.adapter.outerHeight()}}],horizontal:[{right:"enter",left:"exited",offset:"100%"},{right:"entered",left:"exit",offset:"right-in-view"},{right:"exit",left:"entered",offset:0},{right:"exited",left:"enter",offset:function(){return-this.adapter.outerWidth()}}]},e=0,i=t[this.axis].length;i>e;e++){var n=t[this.axis][e];this.createWaypoint(n)}},e.prototype.createWaypoint=function(t){var e=this;this.waypoints.push(new i({context:this.options.context,element:this.options.element,enabled:this.options.enabled,handler:function(t){return function(i){e.options[t[i]].call(e,i)}}(t),offset:t.offset,horizontal:this.options.horizontal}))},e.prototype.destroy=function(){for(var t=0,e=this.waypoints.length;e>t;t++)this.waypoints[t].destroy();this.waypoints=[]},e.prototype.disable=function(){for(var t=0,e=this.waypoints.length;e>t;t++)this.waypoints[t].disable()},e.prototype.enable=function(){for(var t=0,e=this.waypoints.length;e>t;t++)this.waypoints[t].enable()},e.defaults={context:window,enabled:!0,enter:t,entered:t,exit:t,exited:t},i.Inview=e}();

/*!
Waypoints Sticky Element Shortcut - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(s){this.options=e.extend({},i.defaults,t.defaults,s),this.element=this.options.element,this.$element=e(this.element),this.createWrapper(),this.createWaypoint()}var e=window.jQuery,i=window.Waypoint;t.prototype.createWaypoint=function(){var t=this.options.handler;this.waypoint=new i(e.extend({},this.options,{element:this.wrapper,handler:e.proxy(function(e){var i=this.options.direction.indexOf(e)>-1,s=i?this.$element.outerHeight(!0):"";this.$wrapper.height(s),this.$element.toggleClass(this.options.stuckClass,i),t&&t.call(this,e)},this)}))},t.prototype.createWrapper=function(){this.options.wrapper&&this.$element.wrap(this.options.wrapper),this.$wrapper=this.$element.parent(),this.wrapper=this.$wrapper[0]},t.prototype.destroy=function(){this.$element.parent()[0]===this.wrapper&&(this.waypoint.destroy(),this.$element.removeClass(this.options.stuckClass),this.options.wrapper&&this.$element.unwrap())},t.defaults={wrapper:'<div class="sticky-wrapper" />',stuckClass:"stuck",direction:"down right"},i.Sticky=t}();

function pdp_bis_timestamp() {
	var d = new Date();
	// UTC
	var year = d.getUTCFullYear();
	var month = to_digits((d.getUTCMonth() + 1), 2);
	var day = to_digits(d.getUTCDate(), 2);
	var hr = to_digits(d.getUTCHours(), 2);
	var min = to_digits(d.getUTCMinutes(), 2);
	var sec = to_digits(d.getUTCSeconds(), 2);
	// PREP
	var output = '';
	output += year;
	output += '-';
	output += month;
	output += '-';
	output += day;
	output += ' ';
	output += hr;
	output += ':';
	output += min;
	output += ':';
	output += sec;
	// SET
	return output;
}

function pdp_bis_form(form) {
	// generate timestamp
	var now = pdp_bis_timestamp();
	// reset datetime value to now
	$(form).find('[data-timestamp]').val(now);
	// copy input email value to field in outside form
	$(form).find('[data-pdp-bis-form-email-hidden]').val(
		$(form).closest('.product-form').find('[data-pdp-bis-form-email-value]').val()
	);
	// complete
	return true;
}

// **************************************************************** //
// ZIPCODE GATEWAY
// **************************************************************** //

// no cookie value
function zipcode_gateway_none_pdp(form) {
	// disable add to cart form
	zipcode_gateway_atc_disable_pdp($(form).parent().parent().get(0));
}

// preload cookie value
function zipcode_gateway_load_pdp(form) {
	// pre-populate zipcode value
	$(form).find('[name="zipcode"]').val(fec_zcg.c);
	$(form).find('[data-zipcode-val]').text(fec_zcg.c);
}

// render pass
function zipcode_gateway_pass_pdp(form, z) {
	// set zipcode value
	$(form).find('[data-zipcode-val]').text(z);
	// hide active msg
	$(form).find('.product-form--zipcode--msg').removeClass('active');
	// show pass msg
	$(form).find('.msg-pass').addClass('active');
	// remove zipcode gateway restriction
	zipcode_gateway_atc_enable_pdp($(form).parent().parent().get(0));
}

// render fail
function zipcode_gateway_fail_pdp(form, z) {
	// set zipcode value
	$(form).find('[data-zipcode-val]').text(z);
	// hide active msg
	$(form).find('.product-form--zipcode--msg').removeClass('active');
	// show fail text
	$(form).find('.msg-fail').addClass('active');
	// add zipcode gateway restriction
	zipcode_gateway_atc_disable_pdp($(form).parent().parent().get(0));
}


function zipcode_gateway_atc_enable_pdp(container) {
	// remove zipcode gateway restriction
	if($(container).hasClass('zipcodegateway')) {
		$(container).removeClass('zipcodegateway');
	}
}

function zipcode_gateway_atc_disable_pdp(container) {
	// add zipcode gateway restriction
	if(!$(container).hasClass('zipcodegateway')) {
		$(container).addClass('zipcodegateway');
	}
}

// initialize
function zipcode_gateway_init(container, none, load, pass, fail) {
	var form = $(container).find('.product-form--zipcode--form');
	// if zip code is not set within cookie (undefined)
	if(!fec_zcg.c) {
		// set load state: no cookie value
		if(typeof none == 'function') {
			console.log( 'zipcode_gateway_init() > CALLING: none()' );
			none(form);
		}
		else {
			zipcode_gateway_none_pdp(form);
		}
	}
	// if zip code is set within cookie (not undefined)
	else {
		// set load state: has cookie value
		if(typeof load == 'function') {
			console.log( 'zipcode_gateway_init() > CALLING: load()' );
			load(form);
		}
		else {
			console.log( 'zipcode_gateway_init() > CALLING: zipcode_gateway_load_pdp()' );
			zipcode_gateway_load_pdp(form);
		}
		// render
		zipcode_gateway_render(fec_zcg, form, pass, fail);
	}
}


// render (have zipcode value: call `pass()` or `fail()`)
function zipcode_gateway_render(cookie, form, pass, fail) {
	
	var cookie_found = false;
	
	if(typeof cookie == 'object') {
		if(cookie && !$.isEmptyObject(cookie)) {
			cookie_found = true;
		}
	}
	
	if(cookie_found) {
		var fec_zcg = cookie;
	}
	else {
		var all_cookies = cookiesParse();
		var fec_zcg = cookieDecode(all_cookies.fec_zcg);
	}
	
	// *** obtain new zipcode value *** //
	
	var z = zipcode_gateway_check(form, true);
	
	// *** update cookie *** //
	
	var updated_fec_zcg = fec_zcg;
	
	// cookie: set zip code value
	updated_fec_zcg.c = z;
	// cookie: set product ID
	updated_fec_zcg.i = $(form).find('[name="product-id"]').val();
	// cookie: set product handle
	updated_fec_zcg.h = $(form).find('[name="product-handle"]').val();
	// cookie: increment n
	updated_fec_zcg.n = updated_fec_zcg.n + 1;
	// cookie: set timestamp
	updated_fec_zcg.z = Math.round(new Date().getTime() / 1000);
	
	// cookie: write updated cookie
	var confirm_fec_zcg_life = (fec_zcg_life) ? fec_zcg_life : 60;
	cookieSet('fec_zcg', cookieEncode(updated_fec_zcg), confirm_fec_zcg_life);
	
	// *** execute `pass()` or `fail()` callbacks //
	
	console.log( 'zipcode_gateway_render() > CALLING: zipcode_gateway_check()' );
	if(zipcode_gateway_check(form)) {
		// activate state: pass
		if(typeof pass == 'function') {
			pass(form, z);
		}
		else {
			zipcode_gateway_pass_pdp(form, z);
		}
	}
	// if fail
	else {
		// activate state: fail
		if(typeof fail == 'function') {
			fail(form, z);
		}
		else {
			zipcode_gateway_fail_pdp(form, z);
		}
	}
	
}

// check if zipcode value (needle) is within zipcode gateway zone zipcodes array (haystack)
function zipcode_gateway_check(form, return_input) {
	
	// *** GET ZIPCODE ZONE ZIPCODES (HAYSTACK) *** //
	
	var zipcodes = $(form).find('[name="zipcode-delivery-zone-zipcodes"]').val().trim().split(',');
	
	// *** VALIDATE INPUT *** //
	
	var validated = false;
	var z = $(form).find('[name="zipcode"]').val().toString();
	// strip whitespace
	z = z.trim();
	// error prevention
	if(z == null || z == '') {
		z = '0';
	}
	// validate
	if(
		z != null
		&&
		z != ''
		&&
		parseInt(z) > 0
		&&
		z.length == 5
	) {
		validated = true;
	}
	
	// *** CHECK FOR NEEDLE IN HAYSTACK *** //
	
	var zipcode_pass = false;
	
	if(
		validated
		&&
		$.inArray(z, zipcodes) > -1
	) {
		zipcode_pass = true;
	}
	
	// *** //
	
	if(return_input) {
		return z;
	}
	else {
		if(zipcode_pass) {
			return true;
		}
		else {
			return false;
		}
	}
	
}


function zipcode_gateway_submit(e, form, pass, fail) {
	// prevent default form submission (page reload)
	e.preventDefault();
	// render
	zipcode_gateway_render(false, form, pass, fail);
	// exit
	return false;
}

// Delivery zones block (new zip widget). Behaviour that only exists in the new presentation:
// single-zip chips submit that zip, the "+ more" chip reveals hidden chips in batches and folds
// them back, and the zip is checked live once five digits are typed. Listeners are delegated,
// so they cover every product form on the page and need no init call. This file can be
// included more than once per page (inc.liquid renders it per template branch), so they are
// bound only once.
function dz_is_active(root) {
	if(root.classList.contains('product-form--zipcode--mode-variant')) {
		return true;
	}
	return root.classList.contains('product-form--zipcode--mode-ab') && document.body.classList.contains('ab-pdp-delivery-zones');
}
// In A/B mode the input is rendered as in control (group A must not differ); the new
// placeholder and numeric keyboard are applied here once the body class is present.
function dz_activate_input(root) {
	var input = root.querySelector('.product-form--zipcode--form--input--field[data-dz-placeholder]');
	if(!input || !dz_is_active(root)) {
		return;
	}
	input.placeholder = input.getAttribute('data-dz-placeholder');
	input.setAttribute('inputmode', 'numeric');
	input.setAttribute('autocomplete', 'postal-code');
	input.removeAttribute('data-dz-placeholder');
}
if(!window.dz_more_bound) {
	window.dz_more_bound = true;
	document.addEventListener('DOMContentLoaded', function() {
		var roots = document.querySelectorAll('.product-form--zipcode--mode-ab');
		for(var i = 0; i < roots.length; i++) {
			dz_activate_input(roots[i]);
		}
	});
	// the split-test class can arrive after load: re-check when the shopper reaches the input
	document.addEventListener('focusin', function(e) {
		var root = e.target.closest && e.target.closest('.product-form--zipcode--mode-ab');
		if(root) {
			dz_activate_input(root);
		}
	});
	// Live check: the zone list is tiny and local, so a complete zip is checked as soon as it is
	// typed, and a partial one clears the previous verdict instead of leaving a stale error.
	document.addEventListener('input', function(e) {
		var input = e.target;
		if(!input.matches || !input.matches('.product-form--zipcode--form--input--field')) {
			return;
		}
		var root = input.closest('.product-form--zipcode');
		if(!root || !dz_is_active(root)) {
			return;
		}
		var form = input.closest('.product-form--zipcode--form');
		var value = input.value.trim();
		if(/^[0-9]{5}$/.test(value)) {
			if(form.getAttribute('data-dz-checked') !== value) {
				form.setAttribute('data-dz-checked', value);
				form.querySelector('[type="submit"]').click();
			}
			return;
		}
		form.removeAttribute('data-dz-checked');
		var msgs = form.querySelectorAll('.product-form--zipcode--msg.active');
		for(var i = 0; i < msgs.length; i++) {
			msgs[i].classList.remove('active');
		}
	});
	document.addEventListener('click', function(e) {
		// single-zip chip: fill the input and run the check through the regular submit path
		var zip_chip = e.target.closest('[data-dz-zip]');
		if(zip_chip) {
			var zip_form = zip_chip.closest('.product-form--zipcode').querySelector('.product-form--zipcode--form');
			zip_form.querySelector('[name="zipcode"]').value = zip_chip.getAttribute('data-dz-zip');
			zip_form.querySelector('[type="submit"]').click();
			return;
		}
		var more = e.target.closest('[data-dz-more]');
		if(!more) {
			return;
		}
		var step = parseInt(more.getAttribute('data-dz-more'), 10) || 5;
		var extra = more.parentNode.querySelectorAll('.product-form--zipcode--chip--extra');
		var hidden = more.parentNode.querySelectorAll('.product-form--zipcode--chip--extra[hidden]');
		var i;
		// everything is revealed: collapse back to the initial set
		if(hidden.length == 0) {
			for(i = 0; i < extra.length; i++) {
				extra[i].setAttribute('hidden', '');
			}
			more.textContent = more.getAttribute('data-dz-more-label');
			return;
		}
		for(i = 0; i < hidden.length && i < step; i++) {
			hidden[i].removeAttribute('hidden');
		}
		if(hidden.length <= step) {
			more.textContent = more.getAttribute('data-dz-less-label');
		}
	});
}

// **************************************************************** //
// AGE GATEWAY
// **************************************************************** //

// preload cookie value
function age_gateway_load_pdp(checkbox) {
	// pre-check agegate checkbox
	$(checkbox).prop('checked', true);
}

// render pass
function age_gateway_pass_pdp(container) {
	// remove age gateway restriction
	age_gateway_atc_enable_pdp(container);
}

// render fail
function age_gateway_fail_pdp(container) {
	// add age gateway restriction
	age_gateway_atc_disable_pdp(container);
}

function age_gateway_atc_enable_pdp(container) {
	// remove age gateway restriction
	if($(container).hasClass('agegateway')) {
		$(container).removeClass('agegateway');
	}
}

function age_gateway_atc_disable_pdp(container) {
	// add age gateway restriction
	if(!$(container).hasClass('agegateway')) {
		$(container).addClass('agegateway');
	}
}

// initialize
function age_gateway_init(container) {
	var checkbox = $(container).find('[data-agegate-checkbox]').get(0);
	// if age gateway is set to passing value within cookie
	if(fec_ag.c == 'y') {
		// set load state: pass
		age_gateway_load_pdp(checkbox);
		// pass
		age_gateway_pass_pdp(container);
	}
	// if no passing value is set within cookie
	else {
		// pass
		age_gateway_fail_pdp(container);
	}
}

function age_gateway_pass_cookie(form) {
	
	var cookie_found = false;
	
	if(typeof fec_ag == 'object') {
		if(fec_ag && !$.isEmptyObject(fec_ag)) {
			cookie_found = true;
		}
	}
	
	if(!cookie_found) {
		var all_cookies = cookiesParse();
		var fec_ag = cookieDecode(all_cookies.fec_ag);
	}
	
	// *** update cookie *** //
	var updated_fec_ag = fec_ag;
	
	// cookie: set passing value
	updated_fec_ag.c = 'y';
	// cookie: set product ID
	updated_fec_ag.i = $(form).find('[name="product-id"]').val();
	// cookie: set product handle
	updated_fec_ag.h = $(form).find('[name="product-handle"]').val();
	// cookie: increment n
	updated_fec_ag.n = updated_fec_ag.n + 1;
	// cookie: set timestamp
	updated_fec_ag.z = Math.round(new Date().getTime() / 1000);
	
	// cookie: write updated cookie
	var confirm_fec_ag_life = (fec_ag_life) ? fec_ag_life : 60;
	cookieSet('fec_ag', cookieEncode(updated_fec_ag), confirm_fec_ag_life);
	
}

function age_gateway_fail_cookie(form) {
	
	var cookie_found = false;
	
	if(typeof fec_ag == 'object') {
		if(fec_ag && !$.isEmptyObject(fec_ag)) {
			cookie_found = true;
		}
	}
	
	if(!cookie_found) {
		var all_cookies = cookiesParse();
		var fec_ag = cookieDecode(all_cookies.fec_ag);
	}
		
	var updated_fec_ag = fec_ag;
	
	// cookie: set failing value
	updated_fec_ag.c = 'n';
	// cookie: set product ID
	updated_fec_ag.i = $(form).find('[name="product-id"]').val();
	// cookie: set product handle
	updated_fec_ag.h = $(form).find('[name="product-handle"]').val();
	// cookie: increment n
	updated_fec_ag.n = updated_fec_ag.n + 1;
	// cookie: set timestamp
	updated_fec_ag.z = Math.round(new Date().getTime() / 1000);
	
	// cookie: write updated cookie
	var confirm_fec_ag_life = (fec_ag_life) ? fec_ag_life : 60;
	cookieSet('fec_ag', cookieEncode(updated_fec_ag), confirm_fec_ag_life);
	
}

// checkbox onchange event
function age_gateway_set(checkbox) {
	var container = $(checkbox).closest('.product-form');
	var form = $(checkbox).closest('.product-form').find('form.pdp-form');
	// if checkbox is checked (age verification passed)
	if($(checkbox).prop('checked') === true) {
		// set pass
		age_gateway_pass_pdp(container);
		// set cookie: pass
		age_gateway_pass_cookie(form);
	}
	// if checkbox is unchecked (age verification failed)
	else {
		// set fail
		age_gateway_fail_pdp(container);
		// set cookie: fail
		age_gateway_fail_cookie(form);
	}
}

function pdp_video_status() {
	
	var pdp_video_targets = [];
	
	$('.Product__Slideshow').find('video').each(function(i) {
		// var this_video = $(this).get(0);
		pdp_video_targets.push($(this).get(0));
		// this_video.pause();
		// console.log( this_video.paused );
	});
	
	for(var i = 0; i < pdp_video_targets.length; i++) {
		var x = i + 0;
	}	
}

function pdp_video_pause_all() {
	$('.Product__Slideshow').find('video').each(function(i) {
		this_video = $(this).get(0);
		if(!this_video.paused) {
			this_video.pause();
		}
	});
}

// **************************************************************** //
// PDP - STICKY CTA BAR
// **************************************************************** //

function pdp_stickycta_scroll() {
	var stickyCTA = $('#pdp-stickycta'),
	stickyMainNav = $('.megamenu'),
	pageWindow = $(window),
	holidayShippingDot = $('#holiday-shipping'),
	position = $(window).scrollTop();
	
		if(screendm_megamenu() == 'desktop') {

			$('#sticky-cta-waypoint').waypoint(function(direction) {
			    if (direction === 'down') {
			      	stickyCTA.addClass('visible');
			      	stickyMainNav.addClass('hide');
			    }
			    else {
			      	stickyCTA.removeClass('visible');
			      	stickyMainNav.removeClass('hide');
			    }
			  }, {
			    offset: '-40px'
			})
	    } else {
		    $('#sticky-cta-waypoint').waypoint(function(direction) {
			    if (direction === 'down') {
			      	stickyCTA.addClass('visible');
			      	holidayShippingDot.addClass('scootUp');
			    }
			    else {
			      	stickyCTA.removeClass('visible');
			      	holidayShippingDot.removeClass('scootUp');
			    }
			  }, {
			    offset: '20px'
			})

			var inview = new Waypoint.Inview({
				  element: $('.footer-area')[0],
				  enter: function(direction) {
				    stickyCTA.removeClass('activated');
			    	stickyCTA.removeClass('visible');
			      	holidayShippingDot.removeClass('scootUp');
				  },
				  entered: function(direction) {
				    //notify('Entered triggered with direction ' + direction)
				  },
				  exit: function(direction) {
				    //notify('Exit triggered with direction ' + direction)
				  },
				  exited: function(direction) {
				    stickyCTA.addClass('visible');
			      	stickyCTA.addClass('activated');
			      	holidayShippingDot.addClass('scootUp');
				  }
				})
	    }

		var scroll = $(window).scrollTop();
	    if(scroll > position) {
			stickyCTA.removeClass('activated');
			stickyMainNav.removeClass('activated');
	    } else {
	        stickyCTA.addClass('activated');
	        stickyMainNav.addClass('activated');
	    }
	    position = scroll;
}
function on_resize() {
	// calculate window height
	$('body').css('--wh', $(window).outerHeight() + 'px');
}
function on_resize() {
	pdp_stickycta_scroll()
}

function open_shipping_modal() {

	var modal = $('#shippingModal');

	var btn = $('.shippingModalLink');

	var close = $('.modal-close');

	btn.click(function() {
	  	modal.css('display','block');
	})

	close.click(function() {
	  	modal.css('display','none');
	})

	$(window).click(function(event) {
	  	if (event.target == modal) {
	    	modal.css('display','none');
	  	}
	})
}

function pdp_3bottles(input, form) {
	// check 'onetime'
	$(form).find('[data-purchase-type-onetime]').prop('checked', true).trigger('onchange');
	// if "3 bottles" chosen
	if(input.value == 3) {
		// hide onetime/subx options
		$(form).find('.product-form--subx').addClass('hide');
		// show faux price options
		$(form).find('.po-3bottles-fauxprice').removeClass('hide');
		// set flag to multiply qty by 3
		$(form).find('.product-form--qty--input--field').data('multiplier', 3);
	}
	// if "1 bottle" chosen
	else {
		// hide faux price options
		$(form).find('.po-3bottles-fauxprice').addClass('hide');
		// show onetime/subx options
		$(form).find('.product-form--subx').removeClass('hide');
		// remove flag to multiply qty
		$(form).find('.product-form--qty--input--field').removeData('multiplier');
	}
}

function pdp_3bottles_select(n) {
	if($('form.pdp-form').length > 0) {
		if($('form.pdp-form').find('input[type="radio"][name="po-3bottles"][value="' + n + '"]').length > 0) {
			$('form.pdp-form').find('input[type="radio"][name="po-3bottles"][value="' + n + '"]').prop('checked', true);
			$('form.pdp-form').find('input[type="radio"][name="po-3bottles"][value="' + n + '"]').trigger('onchange');
		}
	}
}

// DESKTOP PDP MEDIA GALLERY

function pdp_media(parent, pos) {
	// thumbs
	$(parent).find('.pdp-media-d-thumbnails').find('.pdp-media-thumbnail-item').removeClass('active');
	$(parent).find('.pdp-media-d-thumbnails').find('[data-pos="' + pos + '"]').addClass('active');
	// fulls
	$(parent).find('.pdp-media-d-fulls').find('.pdp-media-item').removeClass('active');
	$(parent).find('.pdp-media-d-fulls').find('[data-pos="' + pos + '"]').addClass('active');
}

function pdp_media_next(parent) {
	var availability_map = [];
	$(parent).find('.pdp-media-d-thumbnails > .pdp-media-thumbnail-item').each(function() {
		availability_map.push($(this).data('pos'));
	});
	var current_pos = $(parent).find('.pdp-media-d-thumbnails > .pdp-media-thumbnail-item.active').data('pos');
	var next_pos = availability_map[($.inArray(current_pos, availability_map) + 1) % availability_map.length];
	pdp_media(parent, next_pos);
}


// MOBILE PDP MEDIA GALLERY

function pdp_owl_height_set(stage) {
	stage.children().each(function() {
		if($(this).find('iframe').length > 0) {
			$(this).find('iframe').css('height', stage.outerHeight() + 'px');
		}
		else {
			var margintop = ((stage.outerHeight() / 2) - ($(this).outerHeight() / 2));
			$(this).find('img').css('height', stage.outerHeight() + 'px');;
			$(this).find('img').css('height', stage.outerHeight() + 'px');;
		}
	});
}

function pdp_owl_height() {
	pdp_owl_height_set(this.$stage);
}

function pdp_owl_init() {
	// set height
	pdp_owl_height_set(this.$stage);
	// redraw media
	setTimeout(function() {
		// this.$element.trigger('next.owl.carousel');
		pdp_select_variant($(this.$element).closest('.pdp-container').find('form.pdp-form').get(0));
	}.bind(this), 1);
}

function pdp_owl_refreshed() {
	// set height
	pdp_owl_height_set(this.$stage);
	// go to var alt media
	var m_gallery_goto = parseInt($(this.$element).data('m_gallery_goto'));
	if(!isNaN(m_gallery_goto)) {
		setTimeout(function() {
			this.$element.trigger('to.owl.carousel', [m_gallery_goto, 0]);
		}.bind(this), 1);
	}
}


$(document).ready(function() {
	
	function pdp_autoplay_video() {
		
		var pdp_video_targets = [];
		var pdp_video_targets_offsets = [];
		
		$('.Product__Slideshow').find('video').each(function(i) {
			pdp_video_targets.push($(this).get(0));
			pdp_video_targets_offsets.push($(this).offset().top + ($(this).outerHeight() / 2));
		});
		
		for(var i = 0; i < pdp_video_targets.length; i++) {
			
			var x = i + 1;
			
			var int_1 = ($(window).scrollTop() + $(window).outerHeight());
			var int_2 = ($(window).scrollTop());
			var int_3 = pdp_video_targets_offsets[i];
			
			if((int_1 > int_3) && (int_2 < int_3)) {

				if($('.Product__Slideshow').data('playing_video_id') != x) {
					$('.Product__Slideshow').data('playing_video_id', x);
					pdp_video_targets[i].play();
				}
			}
			else {
				if($('.Product__Slideshow').data('playing_video_id') == x) {
					// remove playing id
					$('.Product__Slideshow').removeData('playing_video_id');
				}
			}
		}
		
	}
	
	function pdp_on_scroll() {		
		pdp_autoplay_video();		
	}
	
	pdp_on_scroll();
	
	$(window).scroll(pdp_on_scroll);
	document.addEventListener('touchmove', pdp_on_scroll, false);
	
	// **************************************************************** //
	// ON RESIZE
	// **************************************************************** //
	
	function pdp_on_resize() {
		pdp_on_scroll();		
	}
	
	pdp_on_resize();
	
	$(window).resize(pdp_on_resize);
	window.addEventListener('orientationchange', pdp_on_resize);
	
});